(()=>{
'use strict';
const VERSION='2.1.2';
if(window.AWNaturalSearchP1?.version===VERSION)return;
const SHORT_LENGTH_MM=750;
const MAX_RESULTS=24;
const MAX_MAIN_PAGES=2;
const PLATFORMS=[
  ['m4-ar15',/\b(?:m4|ar\s*[-/]?\s*15|ar15)\b/i,'M4 / AR15'],
  ['hi-capa',/\b(?:hi\s*[- ]?capa|hicapa)\b/i,'Hi-Capa'],
  ['hk416',/\bhk\s*[- ]?416\b/i,'HK416'],
  ['scorpion-evo',/\b(?:cz\s*)?scorpion\s*evo\b/i,'CZ Scorpion EVO'],
  ['glock',/\bglock\b/i,'Glock'],
  ['mp5',/\bmp\s*[- ]?5\b/i,'MP5'],
  ['g36',/\bg\s*[- ]?36\b/i,'G36'],
  ['ak',/\b(?:ak\s*[- ]?(?:47|74|12|105)?|akm)\b/i,'AK']
];
const PLATFORM_URLS={
  'm4-ar15':'/pages/airsoft-m4-ar15','hi-capa':'/pages/airsoft-hi-capa','hk416':'/pages/compatibilite-airsoft-hk416',
  'scorpion-evo':'/collections/repliques-airsoft-univers-scorpion-evo-3','glock':'/pages/airsoft-glock',
  'mp5':'/pages/compatibilite-airsoft-mp5','g36':'/pages/compatibilite-airsoft','ak':'/pages/airsoft-ak'
};
const FEATURES=[
  ['brushless',/\b(?:brushless|bldc)\b/i],['etu',/\betu\b/i],['mosfet',/\bmosfet\b/i],
  ['hpa',/\bhpa\b/i],['gbbr',/\bgbbr\b/i],['aeg',/\baeg\b/i],
  ['deans',/\b(?:t\s*[- ]?dean|deans?)\b/i],['mini-tamiya',/\bmini\s*[- ]?tamiya\b/i],
  ['11.1v',/\b11[,.]1\s*v\b/i],['7.4v',/\b7[,.]4\s*v\b/i]
];
const accent=(v='')=>String(v).normalize('NFD').replace(/[\u0300-\u036f]/g,'');
const norm=(v='')=>accent(v).toLowerCase().replace(/[’']/g,' ').replace(/[₂²]/g,'2').replace(/[₀⁰]/g,'0').replace(/[^a-z0-9.+/<>=%-]+/g,' ').replace(/\s+/g,' ').trim();
const compact=(v='')=>norm(v).replace(/[^a-z0-9]+/g,'');
const esc=(v='')=>String(v).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
const pathOf=(h='')=>{try{return new URL(h,location.href).pathname}catch(_){return''}};
const n=(v)=>Number(String(v).replace(',','.'));

function platformTarget(raw){
  for(const [key,re,label] of PLATFORMS) if(re.test(raw)) return {type:'platform',key,label,query:label};
  return null;
}
function modelTarget(raw){
  const after=raw.match(/(?:\bpour\b|\bcompatible(?:s)?\s+(?:avec\s+)?)([^,;]+)/i)?.[1]?.trim()||raw;
  const patterns=[
    /\b(SA[- ]?[A-Z]\d{2,4})\b/i,
    /\b(CM[. -]?\d{2,4})\b/i,
    /\b([A-Z]{1,6}[- ]?[A-Z]{0,3}[- ]?\d{2,5}(?:[.\-/][A-Z0-9]{1,6})*)\b/i
  ];
  for(const re of patterns){
    const m=after.match(re);
    if(m){
      const label=m[1].replace(/\s+/g,'-').replace(/-+/g,'-').toUpperCase();
      if(!/^M4$/i.test(label)&&!/^MP5$/i.test(label)&&!/^G36$/i.test(label)) return {type:'model',key:compact(label),label,query:label};
    }
  }
  const ex=raw.match(/(?:\bpour\b|\bcompatible(?:s)?\s+(?:avec\s+)?)([^,;]+)/i);
  if(ex?.[1]&&compact(ex[1]).length>=4) return {type:'text',key:compact(ex[1]),label:ex[1].trim(),query:ex[1].trim()};
  return null;
}
function category(raw){
  const q=norm(raw);
  if(/\b(?:batterie|lipo|li ion|nimh|accu)\b/.test(q)) return 'power';
  if(/\b(?:chargeur de batterie|chargeur batterie|charger battery)\b/.test(q)) return 'power';
  if(/\b(?:chargeur|magazine|mid cap|high cap|hi cap|low cap)\b/.test(q)) return 'magazine';
  if(/\b(?:hop[- ]?up|hopup|gearbox|nozzle|piston|engrenage|ressort|canon interne|joint[- ]?hop|bucking|nub|moteur|motor|mosfet|etu|tappet|cylindre)\b/.test(q)) return 'internal';
  if(/\b(?:red dot|point rouge|optique|viseur|lunette|silencieux|suppressor|traceur|tracer|rail|montage|mount|adaptateur|bipied|poignee)\b/.test(q)) return 'mounting';
  if(/\b(?:entretien|maintenance|huile|graisse|lubrifiant|nettoy)\b/.test(q)) return 'maintenance';
  if(/\b(?:upgrade|amelior|optimis|custom)\b/.test(q)) return 'upgrade';
  if(/\b(?:replique|aeg|gbbr|gbb|hpa|aep|sniper|fusil|carabine|pistolet)\b/.test(q)) return 'replica';
  return '';
}
function parseBound(raw,units,convert){
  const s=accent(raw).toLowerCase().replace(/[₂²]/g,'2').replace(/[₀⁰]/g,'0');
  const u='('+units+')';
  let m=s.match(new RegExp('(?:entre|de)\\s*(\\d+(?:[.,]\\d+)?)\\s*'+u+'?\\s*(?:et|a|à|-)\\s*(\\d+(?:[.,]\\d+)?)\\s*'+u,'i'));
  if(m){let a=convert(n(m[1]),m[2]||m[4]),b=convert(n(m[3]),m[4]);if(a>b)[a,b]=[b,a];return{min:a,max:b}}
  m=s.match(new RegExp('(?:moins\\s+de|sous|jusqu(?:a|à)?|max(?:imum)?|<=|<)\\s*(\\d+(?:[.,]\\d+)?)\\s*'+u,'i'));
  if(m)return{min:null,max:convert(n(m[1]),m[2])};
  m=s.match(new RegExp('(?:plus\\s+de|au\\s+moins|min(?:imum)?|>=|>)\\s*(\\d+(?:[.,]\\d+)?)\\s*'+u,'i'));
  if(m)return{min:convert(n(m[1]),m[2]),max:null};
  return{min:null,max:null};
}
function parseMetrics(raw){
  const weight=parseBound(raw,'kg|g',(v,u)=>/kg/i.test(u)?v*1000:v);
  const length=parseBound(raw,'mm|cm|m',(v,u)=>/^(?:m)$/i.test(u)?v*1000:/cm/i.test(u)?v*10:v);
  const power=parseBound(raw,'j|joule(?:s)?',(v)=>v);
  return{
    weight,length,power,
    short:/\b(?:court|courte|compact|compacte|cqb|pdw)\b/i.test(accent(raw)),
    has:weight.min!=null||weight.max!=null||length.min!=null||length.max!=null||power.min!=null||power.max!=null
  };
}
function parsePrice(raw){
  const s=accent(raw).toLowerCase();
  if(!/(?:€|\beur\b|euros?|\bprix\b|\bbudget\b)/i.test(raw)) return{min:null,max:null,label:''};
  let m=s.match(/(?:moins\s+de|sous|jusqu(?:a|à)?|max(?:imum)?|<=|<)\s*(\d+(?:[.,]\d+)?)\s*(?:€|eur|euros?)/i);
  if(m){const max=Math.round(n(m[1])*100);return{min:null,max,label:'≤ '+max/100+' €'}}
  m=s.match(/(?:plus\s+de|au\s+moins|min(?:imum)?|>=|>)\s*(\d+(?:[.,]\d+)?)\s*(?:€|eur|euros?)/i);
  if(m){const min=Math.round(n(m[1])*100);return{min,max:null,label:'≥ '+min/100+' €'}}
  return{min:null,max:null,label:''};
}
function parse(raw){
  const target=platformTarget(raw)||modelTarget(raw);
  let cat=category(raw);
  const metrics=parseMetrics(raw);
  if(!cat&&target&&(metrics.has||metrics.short))cat='replica';
  const q=norm(raw);
  const semantic={
    battery:/\b(?:batterie|lipo|li ion|nimh|accu)\b/.test(q),
    batteryCharger:/\b(?:chargeur de batterie|chargeur batterie)\b/.test(q),
    magazine:/\b(?:chargeur|magazine|mid cap|high cap|hi cap|low cap)\b/.test(q)&&!/\b(?:chargeur de batterie|chargeur batterie)\b/.test(q),
    hopup:/\b(?:hop[- ]?up|hopup|bucking|joint[- ]?hop|nub)\b/.test(q),
    upgrade:/\b(?:upgrade|amelior|optimis|custom)\b/.test(q),
    version51:/\b5[.,]1\b/.test(q),
    version43:/\b4[.,]3\b/.test(q)
  };
  const features=FEATURES.filter(([,re])=>re.test(raw)).map(([key])=>key);
  const explicitCompatibility=/\bcompatible(?:s|ment)?\b|\bcompatibilit[eé]\b|\bpour\b/i.test(raw);
  const impliedCompatibility=!!target&&(['power','magazine','internal','upgrade','mounting'].includes(cat)||(cat==='replica'&&(metrics.has||metrics.short)));
  const compatibilityRequired=explicitCompatibility||impliedCompatibility;
  return{raw,normalized:q,target,category:cat,metrics,price:parsePrice(raw),semantic,features,compatibilityRequired};
}
function values(text,key){
  const out=[];const re=new RegExp('AWMETRIC:'+key+'=([0-9.]+)','gi');let m;
  while((m=re.exec(String(text||''))))out.push(Number(m[1]));
  return out.filter(Number.isFinite);
}
function withinAll(vals,b){
  if(b.min==null&&b.max==null)return true;
  if(!vals.length)return false;
  return vals.every(v=>(b.min==null||v>=b.min)&&(b.max==null||v<=b.max));
}
function proofKind(c){return String(c.proof||'').toLowerCase()}
function proofRank(c){
  const k=proofKind(c);
  if(k.startsWith('exact_model')&&!c.conditional)return 6;
  if(k.startsWith('exact_model'))return 5;
  if(k.startsWith('platform')&&!c.conditional)return 4;
  if(k.startsWith('platform'))return 3;
  return 0;
}
function isStrongReplicaTitle(title,p){
  const t=norm(title);
  if(/\b(?:vis|sac|mallette|housse|support|kit|goupille|adaptateur|chargeur|magazine|piece|pieces|accessoire|canon interne|canon externe|outer barrel|crosse|tube|corps|receiver|grip|poignee|holster|poche|levier|arretoir|selecteur|detente|trigger|release|ressort|engrenage|gear|nozzle|joint|hop[- ]?up|chambre|mosfet|moteur|piston|cylindre|rail|garde[- ]?main|handguard)\b/.test(t))return false;
  return /^(?:replique|pistolet|sniper|fusil|carabine)\b/.test(t);
}
function platformTextOk(text,t){
  const s=norm(text),k=compact(text);
  if(t.key==='m4-ar15')return k.includes('m4')||k.includes('ar15')||k.includes('ddm4')||k.includes('mk18');
  if(t.key==='hi-capa')return /\bhi[- ]?capa\b|\bhicapa\b|\b2011\b/.test(s);
  if(t.key==='scorpion-evo')return k.includes('scorpionevo');
  if(t.key==='hk416')return k.includes('hk416');
  if(t.key==='mp5')return k.includes('mp5');
  if(t.key==='g36')return k.includes('g36');
  if(t.key==='glock')return k.includes('glock');
  if(t.key==='ak')return k.includes('ak47')||k.includes('ak74')||k.includes('akm');
  return k.includes(compact(t.label));
}
function targetOk(c,t){
  if(!t)return true;
  const models=norm(c.models),platforms=norm(c.platforms),title=norm(c.title),text=norm(c.text);
  if(t.type==='model'){
    const k=compact(t.query||t.label);
    return compact(models).includes(k)||compact(title).includes(k)||compact(text).includes(k);
  }
  if(t.type==='text'){
    const k=compact(t.query||t.label);
    return compact(models).includes(k)||compact(title).includes(k)||compact(text).includes(k);
  }
  return platformTextOk(platforms,t)||platformTextOk(title,t)||platformTextOk(text,t);
}
function contextOk(c,p){
  const x=String(c.context||'').trim().toLowerCase().replace(/\s+/g,'_');
  const title=norm(c.title);
  if(!p.category)return true;
  if(p.category==='power'){
    if(x!=='power')return false;
    if(p.semantic.battery&&!p.semantic.batteryCharger){
      if(!/\b(?:batterie|lipo|li ion|nimh|accu)\b/.test(title))return false;
      if(/^chargeur\b/.test(title)&&!/^kit batterie\b/.test(title))return false;
    }
    if(p.semantic.batteryCharger&&!/\bchargeur\b/.test(title))return false;
    return true;
  }
  if(p.category==='magazine')return ['magazine','magazine_aeg','magazine_gas','magazine_co2'].includes(x);
  if(p.category==='internal')return x==='internal';
  if(p.category==='upgrade')return x==='internal';
  if(p.category==='mounting')return x==='mounting';
  if(p.category==='maintenance')return x==='consumable'||x==='atelier';
  if(p.category==='replica')return x==='replica'&&isStrongReplicaTitle(c.title,p);
  return true;
}
function semanticOk(c,p){
  const title=norm(c.title),text=norm(c.text);
  if(p.semantic.hopup&&!/\b(?:hop[- ]?up|hopup|bucking|joint[- ]?hop|chambre[- ]?hop|nub|tensioner)\b/.test(title))return false;
  if(p.semantic.version51&&!/\b5[., ]?1\b/.test(title+' '+text))return false;
  if(p.semantic.version43&&!/\b4[., ]?3\b/.test(title+' '+text))return false;
  for(const f of p.features){
    if(f==='aeg'||f==='gbbr'||f==='hpa'){
      if(!norm(title+' '+text).includes(norm(f)))return false;
    }else if(!norm(title+' '+text).includes(norm(f)))return false;
  }
  return true;
}
function metricOk(c,p){
  const t=String(c.text||'');
  if(!withinAll(values(t,'weight_g'),p.metrics.weight))return false;
  if(!withinAll(values(t,'length_mm'),p.metrics.length))return false;
  if(!withinAll(values(t,'power_j'),p.metrics.power))return false;
  if(p.metrics.short){
    const lens=values(t,'length_mm');
    const facet=norm(t);
    const shortByFacet=/awfacet:length_band=[^\n]*(?:court|compact|cqb)|\b(?:cqb|compact|courte?|pdw)\b/.test(facet);
    const shortByMetric=lens.length>0&&lens.every(v=>v<=SHORT_LENGTH_MM);
    if(!shortByFacet&&!shortByMetric)return false;
  }
  return true;
}
function priceOk(c,p){const v=Number(c.price||0);return (p.price.min==null||v>=p.price.min)&&(p.price.max==null||v<=p.price.max)&&(p.price.min==null&&p.price.max==null||v>0)}
function proofOk(c,p){
  if(!p.compatibilityRequired||!p.target)return true;
  const k=proofKind(c);
  if(p.target.type==='model'||p.target.type==='text'){
    if(k.startsWith('exact_model'))return true;
    return c.score>=90&&!!c.date&&targetOk(c,p.target);
  }
  if(p.target.type==='platform'){
    if(k.startsWith('exact_model')||k.startsWith('platform'))return true;
    return c.score>=90&&!!c.date&&platformTextOk(c.platforms,p.target);
  }
  return true;
}
function candidate(el,source=''){
  const a=el.querySelector?.('a[href*="/products/"]');
  return{
    el,source:source||el.dataset.awNaturalSource||'search',
    url:pathOf(el.dataset.awNaturalUrl||a?.href||''),
    title:el.dataset.awNaturalTitle||el.dataset.awSearchTitle||a?.textContent?.trim()||'',
    context:el.dataset.awNaturalContext||'',
    models:el.dataset.awNaturalModels||el.dataset.awSearchModels||'',
    platforms:el.dataset.awNaturalPlatforms||'',
    text:el.dataset.awNaturalSearchText||el.textContent||'',
    price:Number(el.dataset.awNaturalPrice||0),
    available:String(el.dataset.awNaturalAvailable??el.dataset.awSearchAvailable)==='true',
    proof:el.dataset.awNaturalProofKind||'',
    conditional:String(el.dataset.awNaturalConditional||'')==='true',
    score:Number(el.dataset.awNaturalScore||0),
    date:el.dataset.awNaturalDate||''
  };
}
function matches(c,p){return !!c.url&&contextOk(c,p)&&targetOk(c,p.target)&&semanticOk(c,p)&&metricOk(c,p)&&priceOk(c,p)&&proofOk(c,p)}
function rank(c,p,idx){
  let s=proofRank(c)*100000;
  if(c.source==='metric-model')s+=9000;else if(c.source==='graph')s+=8000;else if(c.source==='model')s+=7000;else if(c.source==='platform')s+=5000;else s+=1000;
  if(p.target&&targetOk(c,p.target))s+=4000;
  if(p.category&&contextOk(c,p))s+=2500;
  if(p.semantic.hopup&&semanticOk(c,p))s+=1800;
  if(p.metrics.has||p.metrics.short)s+=metricOk(c,p)?1600:0;
  if(c.available)s+=80;
  s+=Math.min(c.score||0,100);
  return s-idx/1000;
}
function sectionUrl(id,term,page=1){
  const u=new URL('/search',location.origin);
  u.searchParams.set('q',term);
  u.searchParams.set('type','product');
  u.searchParams.set('section_id',id);
  if(page>1)u.searchParams.set('page',String(page));
  return u;
}
async function fetchDoc(id,term,page=1){
  const r=await fetch(sectionUrl(id,term,page),{headers:{Accept:'text/html','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'});
  if(!r.ok)return null;
  return new DOMParser().parseFromString(await r.text(),'text/html');
}
async function modelCandidates(term){
  const d=await fetchDoc('aw-search-natural-model-products-p19',term);
  return d?[...d.querySelectorAll('[data-aw-natural-candidate]')].map(el=>candidate(el,'model')):[];
}
async function platformCandidates(term){
  const d=await fetchDoc('aw-search-natural-intent-data-p1',term);
  return d?[...d.querySelectorAll('[data-aw-natural-candidate]')].map(el=>candidate(el,el.dataset.awNaturalSource==='graph'?'graph':'platform')):[];
}
async function platformMetricCandidates(term){
  const d=await fetchDoc('aw-search-natural-platform-models-p0',term);
  return d?[...d.querySelectorAll('[data-aw-natural-candidate]')].map(el=>candidate(el,'metric-model')):[];
}
async function mainCandidates(term,pages=MAX_MAIN_PAGES){
  const out=[];
  for(let page=1;page<=pages;page++){
    const d=await fetchDoc('main-search',term,page);
    if(!d)break;
    const els=[...d.querySelectorAll('[data-aw-search-results-grid] [data-aw-search-result][data-aw-search-product="true"]')];
    els.forEach(el=>out.push(candidate(el,'search')));
    if(els.length<24)break;
  }
  return out;
}
function relaxedQueries(p){
  const label=p.target?.label||'';
  const q=[];
  const add=v=>{v=String(v||'').trim();if(v&&!q.some(x=>norm(x)===norm(v)))q.push(v)};
  if(p.semantic.hopup&&label){add(label+' hop-up');add('joint[- ]?hop-up '+label);add(label)}
  else if(p.semantic.battery&&label){add('batterie '+label);add(label)}
  else if(p.semantic.magazine&&label){add('chargeur '+label);add(label)}
  else if(label)add(label);
  else add(p.raw);
  return q.slice(0,3);
}
async function gather(p){
  const current=[...document.querySelectorAll('[data-aw-search-results-grid] [data-aw-search-result][data-aw-search-product="true"]')].map(el=>candidate(el,'current'));
  let dedicated=[];
  try{
    if(p.target?.type==='model'||p.target?.type==='text') dedicated=await modelCandidates(p.target.query);
    else if(p.target?.type==='platform') dedicated=await platformCandidates(p.target.label);
  }catch(_){}
  let metricDedicated=[];
  if((p.metrics.has||p.metrics.short)&&p.target?.type==='platform'){
    try{metricDedicated=await platformMetricCandidates(p.target.label)}catch(_){}
  }
  let filtered=[...metricDedicated,...dedicated].filter(c=>matches(c,p));
  let extra=[];
  if(filtered.length===0){
    const qs=relaxedQueries(p).slice(0,2);
    const pages=(p.metrics.has||p.metrics.short)?8:1;
    const batches=await Promise.all(qs.map(q=>mainCandidates(q,pages).catch(()=>[])));
    extra=batches.flat();
  }
  const all=[...metricDedicated,...dedicated,...extra,...current];
  const best=new Map;
  all.forEach((c,idx)=>{
    if(!matches(c,p))return;
    const old=best.get(c.url);
    c._idx=idx;
    if(!old||rank(c,p,idx)>rank(old,p,old._idx||0))best.set(c.url,c);
  });
  const arr=[...best.values()];
  arr.sort((a,b)=>rank(b,p,b._idx||0)-rank(a,p,a._idx||0));
  return arr.slice(0,MAX_RESULTS);
}
function makeGrid(){
  let g=document.querySelector('[data-aw-search-results-grid]');
  if(g)return g;
  const page=document.querySelector('.search-results-head')?.parentElement||document.querySelector('.section .page-width');
  const empty=page?.querySelector('.search-empty:not(.aw-search-intents__empty)');
  if(!page)return null;
  g=document.createElement('div');
  g.className='product-grid product-grid--4 aw-natural-search__generated-grid';
  g.setAttribute('role','list');
  g.dataset.awSearchResultsGrid='';
  if(empty)empty.before(g);else page.appendChild(g);
  if(empty)empty.hidden=true;
  return g;
}
function badgeFor(c){
  const k=proofKind(c);
  if(k.startsWith('exact_model'))return c.conditional?'Modèle exact documenté · conditions à vérifier':'Compatibilité modèle exact vérifiée';
  if(k.startsWith('platform'))return c.conditional?'Plateforme documentée · modèle exact à confirmer':'Compatibilité plateforme vérifiée';
  return '';
}
function importCandidate(c,idx){
  const el=document.importNode(c.el,true);
  el.hidden=false;
  el.setAttribute('role','listitem');
  el.dataset.awSearchResult='';
  el.dataset.awSearchIntent='products';
  el.dataset.awSearchProduct='true';
  el.dataset.awSearchAvailable=c.available?'true':'false';
  el.dataset.awNaturalImported='true';
  el.dataset.awNaturalSource=c.source;
  const badge=badgeFor(c);
  if(badge){
    const title=el.querySelector('.product-card-v3__title')||el.querySelector('h3');
    if(title&&!el.querySelector('[data-aw-natural-proof-badge]')){
      const b=document.createElement('span');b.className='aw-natural-search__badge';b.dataset.awNaturalProofBadge='true';b.textContent=badge;title.before(b);
    }
  }
  const img=el.querySelector('img');
  if(img){
    if(idx===0){img.loading='eager';img.fetchPriority='high'}
    else{img.loading='lazy';img.removeAttribute('fetchpriority')}
  }
  return el;
}
function chips(p){
  const out=[];
  if(p.category)out.push(({power:'Batteries / alimentation',magazine:'Chargeurs de réplique',internal:'Hop-Up / pièces internes',upgrade:'Upgrade / pièces internes',mounting:'Accessoires / montage',maintenance:'Entretien',replica:'Répliques'})[p.category]||p.category);
  if(p.target)out.push(p.target.label);
  if(p.semantic.hopup)out.push('Hop-Up');
  if(p.semantic.version51)out.push('5.1');
  if(p.semantic.version43)out.push('4.3');
  if(p.metrics.weight.max!=null)out.push('Poids ≤ '+Math.round(p.metrics.weight.max)+' g');
  if(p.metrics.weight.min!=null)out.push('Poids ≥ '+Math.round(p.metrics.weight.min)+' g');
  if(p.metrics.length.max!=null)out.push('Longueur ≤ '+Math.round(p.metrics.length.max)+' mm');
  if(p.metrics.short)out.push('Format court / compact');
  if(p.price.label)out.push(p.price.label);
  p.features.forEach(f=>{if(!out.includes(f.toUpperCase()))out.push(f.toUpperCase())});
  return out;
}
function summary(p,count){
  let m=document.querySelector('[data-aw-natural-search-summary]');
  if(!m){
    const h=document.querySelector('.search-results-head');
    if(!h)return;
    m=document.createElement('div');m.dataset.awNaturalSearchSummary='true';m.className='aw-natural-search';h.after(m);
  }
  const cc=chips(p);
  const proof=p.compatibilityRequired&&p.target?'<p class="aw-natural-search__proof"><strong>Filtre de compatibilité actif :</strong> les résultats génériques sans rattachement AW au modèle ou à la plateforme sont exclus.</p>':'<p class="aw-natural-search__proof">Le moteur applique les catégories et contraintes détectées avant la disponibilité. Il préfère l’absence de résultat à un produit hors intention.</p>';
  m.innerHTML='<div class="aw-natural-search__head"><span>RECHERCHE NATURELLE AW · P0</span><strong>'+count+' résultat'+(count>1?'s':'')+' conforme'+(count>1?'s':'')+' à l’intention</strong></div><div class="aw-natural-search__chips">'+cc.map(x=>'<span>'+esc(x)+'</span>').join('')+'</div>'+proof;
  m.hidden=false;m.classList.remove('aw-natural-search--reserved');
}
function emptyState(p,g){
  let e=document.querySelector('[data-aw-natural-search-empty]');
  if(!e){e=document.createElement('div');e.className='aw-natural-search__empty';e.dataset.awNaturalSearchEmpty='true';g.before(e)}
  let reason='Aucun produit ne satisfait toutes les contraintes détectées avec les données AW actuellement disponibles.';
  if(p.metrics.has||p.metrics.short)reason='Aucune réplique publiée ne possède actuellement toutes les mesures vérifiées correspondant à ces contraintes. Le moteur ne remplit pas les valeurs manquantes et n’utilise pas les produits brouillon.';
  else if(p.semantic.batteryCharger&&p.target)reason='Aucun chargeur de batterie suffisamment documenté n’est rattaché à cette cible. Les chargeurs de réplique et accessoires de chargeur sont exclus.';
  else if(p.semantic.battery&&p.target)reason='Aucune batterie suffisamment documentée ne correspond à cette cible avec les données AW disponibles.';
  else if(p.semantic.hopup&&p.target)reason='Aucune pièce Hop-Up rattachée à cette plateforme ou version n’est suffisamment documentée pour être proposée sans approximation.';
  else if(p.semantic.magazine&&p.target)reason='Aucun chargeur de réplique suffisamment documenté ne correspond à cette cible. Les chargeurs de batterie, speedloaders et accessoires de chargeur sont exclus.';
  const targetUrl=p.target?.type==='platform'?(PLATFORM_URLS[p.target.key]||'/pages/compatibilite-airsoft'):'/pages/compatibilite-airsoft';
  e.innerHTML='<strong>'+esc(reason)+'</strong><span>Vous pouvez vérifier le modèle exact dans Compatibility AW ou élargir volontairement la recherche.</span><div class="aw-natural-search__choices"><a href="/pages/compatibilite-airsoft">Ouvrir Compatibility AW</a><a href="'+esc(targetUrl)+'">Voir la plateforme</a></div>';
  document.querySelectorAll('[data-aw-zero-recovery]').forEach(x=>x.hidden=true);
}
function finishStage(){
  const stage=document.querySelector('[data-aw-natural-stage]');
  stage?.classList.remove('is-pending');
  document.documentElement.dataset.awNaturalSearchReady=VERSION;
}
async function apply(){
  const raw=new URLSearchParams(location.search).get('q')?.trim()||'';
  if(!raw){finishStage();return}
  const p=parse(raw);
  const signal=!!(p.category||p.target||p.metrics.has||p.metrics.short||p.semantic.hopup||p.price.min!=null||p.price.max!=null||p.features.length);
  if(!signal){finishStage();return}
  const g=makeGrid();
  if(!g){finishStage();return}
  g.querySelectorAll('[data-aw-natural-imported="true"]').forEach(x=>x.remove());
  const originals=[...g.querySelectorAll('[data-aw-search-result][data-aw-search-product="true"]:not([data-aw-natural-imported="true"])')];
  originals.forEach(x=>{x.dataset.awNaturalOriginal='true';x.hidden=true});
  let results=[];
  try{results=await gather(p)}catch(err){console.warn('[AW Natural Search P0]',err)}
  results.forEach((c,i)=>g.appendChild(importCandidate(c,i)));
  const scope=g.closest('[data-aw-natural-stage]')||g.parentElement||document;
  scope.querySelectorAll('nav[aria-label="Pagination"], .pagination').forEach(x=>{x.hidden=true;x.dataset.awNaturalPaginationHidden='true'});
  const oldEmpty=document.querySelector('[data-aw-natural-search-empty]');
  if(results.length){oldEmpty?.remove();document.querySelectorAll('[data-aw-zero-recovery]').forEach(x=>x.hidden=true)}
  else emptyState(p,g);
  summary(p,results.length);
  const h=document.querySelector('.search-results-head .heading');
  if(h)h.textContent=results.length?results.length+' résultat'+(results.length>1?'s':'')+' correspondant à l’intention':'0 résultat vérifié pour toutes les contraintes';
  const status=document.querySelector('[data-aw-search-intent-status]');
  if(status)status.textContent=results.length?results.length+' produit'+(results.length>1?'s':'')+' filtré'+(results.length>1?'s':'')+' par intention':'Aucun produit vérifié ne satisfait toutes les contraintes';
  const reapply=()=>{
    const active=document.querySelector('[data-aw-search-intent-button].is-active')?.dataset.awSearchIntentButton||'all';
    const show=active==='all'||active==='products';
    results.forEach(c=>{const el=[...g.querySelectorAll('[data-aw-natural-imported="true"]')].find(x=>pathOf(x.dataset.awNaturalUrl||x.querySelector('a[href*="/products/"]')?.href||'')===c.url);if(el)el.hidden=!show});
    originals.forEach(x=>x.hidden=true);
  };
  document.querySelector('[data-aw-search-intents]')?.addEventListener('click',()=>setTimeout(reapply,0),{passive:true});
  finishStage();
  try{window.AWAnalytics?.track?.('search_natural_p0_applied',{version:VERSION,query:raw.slice(0,160),category:p.category||'',target:p.target?.label||'',compatibility_required:p.compatibilityRequired,result_count:results.length,metric_filter:p.metrics.has||p.metrics.short})}catch(_){}
}
const boot=()=>apply().catch(err=>{console.warn('[AW Natural Search P0] QA-safe failure',err);finishStage()});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else queueMicrotask(boot);
document.addEventListener('shopify:section:load',boot);
window.AWNaturalSearchP1={version:VERSION,parse,apply};
})();